import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import './HeroDetails.css';

function HeroDetails() {
  const { personId } = useParams();
  const navigate = useNavigate();
  const [person, setPerson] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPerson();
  }, [personId]);

  const fetchPerson = async () => {
    try {
      const token = localStorage.getItem('accessToken');
      const response = await axios.get(
        `/api/famous-people/${personId}`,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );
      setPerson(response.data);
    } catch (error) {
      console.error('Error fetching person:', error);
      if (error.response?.status === 404) {
        alert('Person not found');
        navigate('/heroes');
      }
    } finally {
      setLoading(false);
    }
  };

  const getCategoryColor = (category) => {
    const colors = {
      politics: '#3b82f6',
      arts: '#8b5cf6',
      science: '#10b981',
      sports: '#f59e0b',
      business: '#ef4444',
      social_reform: '#ec4899',
      literature: '#6366f1',
      education: '#14b8a6'
    };
    return colors[category] || '#6b7280';
  };

  const formatYears = (birthYear, deathYear) => {
    if (!birthYear) return '';
    if (deathYear) return `${birthYear} - ${deathYear}`;
    return `${birthYear} - Present`;
  };

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  if (!person) {
    return <div className="error">Person not found</div>;
  }

  return (
    <div>
      <Navbar />

      <div className="hero-details-page">
        <button className="back-btn" onClick={() => navigate('/heroes')}>
          ← Back to Heroes
        </button>

        <div className="hero-card">
          <div className="hero-photo-large">
            {person.photo_url ? (
              <img src={person.photo_url} alt={person.name} />
            ) : (
              <div className="photo-placeholder-large">
                {person.name.charAt(0)}
              </div>
            )}
          </div>

          <div className="hero-info">
            <h1>{person.name}</h1>
            {person.title && <p className="hero-title">{person.title}</p>}
            <p className="hero-years">{formatYears(person.birth_year, person.death_year)}</p>
            <span
              className="category-badge"
              style={{ backgroundColor: getCategoryColor(person.category) }}
            >
              {person.category.replace('_', ' ')}
            </span>
          </div>

          <div className="hero-section">
            <h2>Biography</h2>
            <p className="hero-biography">{person.biography}</p>
          </div>

          {person.achievements && person.achievements.length > 0 && (
            <div className="hero-section">
              <h2>Major Achievements</h2>
              <ul className="achievements-list">
                {person.achievements.map((achievement, index) => (
                  <li key={index}>{achievement}</li>
                ))}
              </ul>
            </div>
          )}

          {person.notable_quote && (
            <div className="hero-section quote-section">
              <h2>Notable Quote</h2>
              <blockquote className="hero-quote">
                "{person.notable_quote}"
              </blockquote>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default HeroDetails;

